import appEnv from 'bundles/enterprise-browse/appEnv';
import appStarterFactory from 'bundles/page/lib/appStarterFactory';

export default appStarterFactory(appEnv);
